import { StrictMode, useEffect, useState } from 'react'
import { createRoot } from 'react-dom/client'
import { TooltipProvider } from './components/ui/tooltip.tsx'
import { ToastProvider } from './components/ui/toast.tsx'
import { RouterProvider, matchList, useRouter } from './lib/router.tsx'
import { AdminModeProvider } from './lib/useAdminMode.tsx'
import { applyTheme, currentTheme, type Theme } from './lib/theme.ts'
import { ListsPage } from './pages/Lists.tsx'
import { ListEditorPage } from './pages/ListEditor.tsx'
import { PrintPage } from './pages/Print.tsx'
import { SettingsPage } from './pages/Settings.tsx'
import { ImportPage } from './pages/Import.tsx'
import { RecommendationsPage } from './pages/Recommendations.tsx'
import { KanonPage } from './pages/Kanon.tsx'
import './globals.css'

function App() {
  const { path } = useRouter()
  const [theme, setTheme] = useState<Theme>(() => currentTheme())

  useEffect(() => applyTheme(theme), [theme])

  const list = matchList(path)
  if (list?.print) return <PrintPage listId={list.id} />

  const toggleTheme = () => setTheme((t) => (t === 'dark' ? 'light' : 'dark'))

  if (list) return <ListEditorPage listId={list.id} theme={theme} onToggleTheme={toggleTheme} />
  if (path.startsWith('/settings')) return <SettingsPage theme={theme} onToggleTheme={toggleTheme} />
  if (path.startsWith('/import')) return <ImportPage theme={theme} onToggleTheme={toggleTheme} />
  if (path.startsWith('/doporucena')) return <RecommendationsPage theme={theme} onToggleTheme={toggleTheme} />
  if (path.startsWith('/kanon')) return <KanonPage theme={theme} onToggleTheme={toggleTheme} />
  return <ListsPage theme={theme} onToggleTheme={toggleTheme} />
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <RouterProvider>
      <AdminModeProvider>
        <TooltipProvider delayDuration={200}>
          <ToastProvider>
            <App />
          </ToastProvider>
        </TooltipProvider>
      </AdminModeProvider>
    </RouterProvider>
  </StrictMode>,
)
